import ProductBlockPreview from "@project/components/ProductBlock/ProductBlockPreview";
import ContentsTypes from "@shared/enums/contentsTypes";
import ContentsCustomTypes from "@project/enums/contentsCustomTypes.enum";
export const ProductBlock = {
    label: "Bloc de présentation produit",
    type: ContentsCustomTypes.PRODUCT_BLOCK,
    Preview: ProductBlockPreview,
    icon: "window",
    editionModal: true,
    editionModalPosition: "top",
    children: [
        {
            label: "Image",
            key: "image",
            type: ContentsTypes.IMAGE,
            value: "",
        },
        {
            label: "Titre",
            key: "title",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Sous-titre",
            key: "subtitle",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Description",
            key: "description",
            type: ContentsTypes.TEXT,
            value: "",
        },
        {
            label: "Lien",
            key: "link",
            type: ContentsTypes.LINK,
            value: "",
        },
    ],
};
